import { Button, Input, message, Popconfirm, Radio, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ErrorItem,
    InputNumberItem,
    DatePickerItem,
    AutoCompleteItem,
    dineroDisabledMask,
} from "../../../../Components/Items";
import dayjs from "dayjs";

const { Option } = Select

class EditarRegistro extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        objetoCarreras: null,
        todasCarreras: [],
        optionEquipos: [],
        todasEquipos: [],
        carreraId: null,
        carreraNuevaId: null
    };

    async componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.setState({ loading: true })
            await axios
                .post(
                    "registroCarrera/datosParaRegistro",
                    { empresaId: this.props.empresaId },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasCarreras: res.data.carreras,
                            objetoCarreras: res.data.carreras.map(valueCarrera => (
                                <Option value={valueCarrera._id} key={valueCarrera._id}>
                                    {valueCarrera.nombre + ' - ' + valueCarrera.distancia + ' km ' + dineroDisabledMask(valueCarrera.precio)}
                                </Option>
                            )),
                            todasEquipos: res.data.equipos,
                            optionEquipos: res.data.equipos.map(valueEquipo => {
                                return {
                                    label: valueEquipo.nombre,
                                    value: valueEquipo.nombre
                                }
                            }),
                        })
                    } else {
                        message.error("Error no se encontro informacion para el registro");
                    }
                });


            await axios
                .post(
                    "registrosCarrera/datosRegistro",
                    { empresaId: this.props.empresaId, registroId: this.props.id },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.formRef.current.setFieldsValue({ ...res.data.registro, fechaNacimiento: dayjs(res.data.registro.fechaNacimiento) })
                        console.log(res.data.registro.carreraId)
                        this.setState({ carreraId: res.data.registro.carreraId.toString(), carreraNuevaId: res.data.registro.carreraId.toString() })
                    } else {
                        message.error("Error no se encontro informacion del registro");
                    }
                });


            this.setState({ loading: false })
        }

    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "registrosCarrera/editarRegistro",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    registroId: this.props.id
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Registro editado exitosamente");
                    this.cerrarModalEditarRegistro();
                } else if (res.data.success === 1) {
                    message.error("No se pudo editar el registro");
                } else {
                    message.error("Sucedió un error y no se pudo editar el registro");
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModalEditarRegistro() {
        this.setState({ visible: false });
        this.props.cerrarModalEditarRegistro();
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
    }

    render() {
        return (
            <ModalItem
                title="Editar Registro"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalEditarRegistro.bind(this)}
                width={800}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="modalEditarRegistro"
                    layout='vertical'
                    bottom={
                        this.state.carreraId !== this.state.carreraNuevaId ?
                            <Popconfirm
                                title={"Al cambiar la carrera se cambiara el monto a pagar"}
                                onConfirm={() => this.formRef.current.formRef.current.submit()}
                                okText="Ok"
                                cancelText="Cancelar"
                            >
                                <Button
                                    type="primary"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                    loading={this.state.loading}
                                >
                                    Editar
                                </Button>
                            </Popconfirm>
                            :
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                                loading={this.state.loading}
                            >
                                Editar
                            </Button>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem
                        label="Nombre Completo"
                        required
                        name="nombre"
                    >
                        <Input
                            placeholder="Nombre completo"
                        />
                    </FormItem>

                    <FormItem
                        label="Fecha de Nacimiento"
                        required
                        name="fechaNacimiento"
                    >
                        <DatePickerItem
                            disabledDate={(current) => {
                                return current && (current < dayjs('1900-01-01') || current > dayjs());
                            }}
                        />
                    </FormItem>

                    <FormItem
                        label="Correo Electrónico"
                        required
                        email={true}
                        name="correo"
                    >
                        <Input
                            placeholder="correo@ejemplo.com"
                        />
                    </FormItem>


                    <FormItem
                        label="Teléfono"
                        required
                        name="telefono"
                    >
                        <InputNumberItem placeholder="Teléfono" celular={true} />
                    </FormItem>


                    <FormItem
                        label="Equipo"
                        name="equipo"
                    >
                        <AutoCompleteItem
                            options={this.state.optionEquipos}
                            virtual={false}
                            placeholder="Nombre del equipo"
                            filterOption={(inputValue, option) => option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                        />
                    </FormItem>

                    <FormItem label="Rama" name="rama" required>
                        <Radio.Group
                        >
                            <Radio value={1}>Varonil</Radio>
                            <Radio value={2}>Femenil</Radio>
                        </Radio.Group>
                    </FormItem>

                    <FormItem
                        label="Carrera"
                        required
                        name="carreraId"
                    >
                        <Select
                            onChange={(value) => this.setState({ carreraNuevaId: value })}
                            placeholder="Selecciona una carrera"
                        >
                            {this.state.objetoCarreras}
                        </Select>
                    </FormItem>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(EditarRegistro);
